module.exports = __webpack_public_path__ + "static/services-cs-flexprint-2792db37b74d5964ce5bb2344cff3acb.png";